module.exports = __webpack_public_path__ + "img/flip-camera-icon.d2f89e67.png";